import { jsx as _jsx } from "react/jsx-runtime";
const GlobalContainer = ({ children, className = '', withTitle = true }) => {
    return (_jsx("div", Object.assign({ className: `main-layout ${className} ${!withTitle && 'without-title'}` }, { children: children })));
};
export default GlobalContainer;
